// extracted by mini-css-extract-plugin
export default {"volumeSlider":"WFsBc6"};